import http from "../../../utils/http";

// 메뉴 불러오기
export const getTaxConsultingCategories = (params = {}) => {
  return new Promise((resolve, reject) => {
    http
      .get("/tax-consulting/categories", { params })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 카테고리 읽음
export const getTaxConsultingCategory = (categoryIdx) => {
  return new Promise((resolve, reject) => {
    http
      .get(`/tax-consulting/categories/${categoryIdx}`)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 카테고리의 게시판종류 불러오기
export const getTaxConsultingBoards = (categoryIdx) => {
  return new Promise((resolve, reject) => {
    http
      .post(`/tax-consulting/board/list`, {
        search: {
          categoryIdx
        }
      })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 게시글 불러오기 {search:{boardIdx,title?,content?,titleAndContent?,writerEmployeeName?,writerEmployeeIdx?}}
export const getTaxConsultingBoardPosts = (body) => {
  return new Promise((resolve, reject) => {
    http
      .post(`/tax-consulting/board/post/list`, body)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};


// 컨설팅 게시글 생성
export const addTaxConsultingPost = (body) => {
  return new Promise((resolve, reject) => {
    http
      .post(`/tax-consulting/board/post`, { ...body })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const editTaxConsultingPost = (idx, body) => {
  return new Promise((resolve, reject) => {
    http
      .put(`/tax-consulting/board/post/${idx}`, { ...body })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 세무 컨설팅 카테고리 추가
export const addTaxConsultingCategory = (body) => {
  return new Promise((resolve, reject) => {
    http
      .post(`/tax-consulting/categories`, { ...body })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 세무컨설팅 카테고리 수정
export const editTaxConsultingCategory = (idx, body) => {
  return new Promise((resolve, reject) => {
    http
      .put(`/tax-consulting/categories/${idx}`, { ...body })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 세무 컨설팅 보드 추가
export const addTaxConsultingBoard = (body) => {
  return new Promise((resolve, reject) => {
    http
      .post(`/tax-consulting/board`, { order: 0, ...body })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
export const editTaxConsultingBoard = (idx, body) => {
  return new Promise((resolve, reject) => {
    http
      .put(`/tax-consulting/board/${idx}`, { order: 0, ...body })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getTaxConsultingContent = (params) => {
  return new Promise((resolve, reject) => {
    http
      .post(`/tax-consulting/role`, params)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const collaborationSettings = (params) => {
  return new Promise((resolve, reject) => {
    http
      .post(`/tax-consulting/collaboration/setting`, params)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
export const getCollaborationCompanies = (categoryIdx) => {
  return new Promise((resolve, reject) => {
    http
      .get(`/tax-consulting/collaboration/setting/${categoryIdx}`)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const addCollaboration = (params) => {
  return new Promise((resolve, reject) => {
    http
      .post(`/tax-consulting/collaboration`, params)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getCollaborations = (params) => {
  return new Promise((resolve, reject) => {
    http
      .post(`/tax-consulting/collaboration/list`, params)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
export const getCollaboration = (idx) => {
  return new Promise((resolve, reject) => {
    http
      .get(`/tax-consulting/collaboration/${idx}`)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const editCollaboration = (idx, params) => {
  return new Promise((resolve, reject) => {
    http
      .put(`/tax-consulting/collaboration/${idx}`, params)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};